import Slider from 'react-slick';
import "./ImageSlider.css";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const settings = {
    dots: false,
    arrows: true, 
    infinite: true,
    speed: 500,
    slidesToShow:2,
    slidesToScroll: 1,
    swipeToSlide: true,
    centerMode: true,
};

const SliderMara = () => (
    <Slider {...settings} className="flex">
        <img src="/products/Mara/Product gallery/1.png" alt="" className=" h-[500px] object-contain " />
        <img src="/products/Mara/Product gallery/2.png" alt="" className="h-[500px] object-contain " />

    </Slider>
);





export default SliderMara;